/**
 * Service centralizing the different routes of the application.
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/03/2022
 * @last_update 16/03/2022
 **/
class RouteService {

    // BASE

    /**
     * Start URL.
     * @type {string}
     * @private
     */
    private _BASIC_URL = "/geoloc/"

    /**
     * Get start URL.
     * @return {string}
     */
    get BASIC_URL(): string {
        return this._BASIC_URL;
    }

    // TABS

    /**
     * Get the URL to access the home page.
     * @return {string}
     */
    getHome() {
        return this.BASIC_URL + "accueil";
    }

    /**
     * Get the URL to access the map page.
     * @return {string}
     */
    getMap() {
        return this.BASIC_URL + "carte";
    }

    getTest() {
        return this.BASIC_URL + "test";
    }

    // OPERATIONS

    getOperation() {
        return this.BASIC_URL + "operation/";
    }

    // INSTALLATION EQUIPMENT

    /**
     * Get the URL to access the lamp installation page.
     * @return {string}
     */
    getEquipmentInstallation() {
        return this.getOperation() + "installation-equipement";
    }


    // INSTALLATION ELEMENT

    /**
     * Get the URL to access the lamp installation page.
     * @return {string}
     */
    getElementInstallation() {
        return this.getOperation() + "installation-element";
    }


    // UNINSTALLATION EQUIPMENT

    /**
     * Get the URL to access the lamp installation page.
     * @return {string}
     */
    getEquipmentUninstallation() {
        return this.getOperation() + "desinstallation-equipement";
    }

    // UNINSTALLATION ELEMENT

    /**
     * Get the URL to access the lamp installation page.
     * @return {string}
     */
    getElementUninstallation() {
        return this.getOperation() + "desinstallation-element";
    }

    // REPLACEMENT ELEMENT

    /**
     * Get the URL to access the battery replacement page.
     * @return {string}
     */
    getElementReplacement() {
        return this.getOperation() + "remplacer-element/";
    }

    // LOCATION

    /**
     * Get the URL to access the geolocation page.
     * @return {string}
     */
    getGeolocation() {
        return this.getOperation() + "geolocaliser/";
    }

    // EDIT

    getEditOperationWithoutParam() {
        return this.getOperation() + "modifier-operation/";
    }

    getEditOperationWithParam() {
        return this.getEditOperationWithoutParam() + ":id";
    }

}

export default new RouteService();
